import { useLanguage } from "@/i18n/LanguageContext";
import { privacyBlocks } from "@/i18n/legalContent";
import LegalBody from "@/components/masar/LegalBody";

export default function PrivacyContent() {
  const { lang } = useLanguage();
  return <LegalBody blocks={privacyBlocks[lang] || privacyBlocks.en} />;
}
